import { ref, Ref } from 'vue'

export default function useClickOutside(wrapperRef: Ref<Node | undefined>) {
  const windowActive = ref(false)

  const clickOutsideListener = (event: any) => {
    if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
      document.removeEventListener('click', clickOutsideListener)
      windowActive.value = false
    }
  }

  const toggleWindow = () => {
    if (windowActive.value) {
      document.removeEventListener('click', clickOutsideListener)
    } else {
      document.addEventListener('click', clickOutsideListener)
    }
    windowActive.value = !windowActive.value
  }

  return {
    windowActive,
    toggleWindow,
  }
}
